export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-gold/25 bg-gradient-to-l from-gold via-[#ffd84d] to-gold py-4" data-testid="services-marquee">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap px-5">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 text-lg font-bold text-ink">
            {item}
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" className="opacity-70">
              <path d="M4 15 A9 9 0 0 1 20 15" stroke="#080B10" strokeWidth="2.6" strokeLinecap="round" />
              <line x1="12" y1="4" x2="12" y2="8" stroke="#080B10" strokeWidth="2.6" strokeLinecap="round" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
